import { connect } from 'react-redux';
import { CommonActions } from '@react-navigation/native';
import { compose, withProps } from 'react-recompose';
import I18n from '../../lib/i18n';
import MyWallet from './MyWallet';
import { balanceSelector } from '../../modules/Customer/selectors';
import config from '../../config';
import Navigation from '../../lib/navigation';
import { fetchWalletForfeitureData, walletForfeitureDataSelector } from '../../modules/Wallet/';

const mapStateToProps = state => ({
  balance: balanceSelector(state),
  dateToCallWalletForfeiture: walletForfeitureDataSelector(state).dateToCallWalletForfeiture,
  hasUnauthenticatedPayment: false,
});

const mapDispatchToProps = {
  fetchWalletForfeitureData,
};

const withMyWalletProps = () => ({
  iconName: 'wallet',
  infoContentText: I18n.t('Dashboard.MyWallet.infoContent'),
  infoDetail: {
    text: I18n.t('Dashboard.MyWallet.infoDetail'),
    linkText: I18n.t('Dashboard.MyWallet.infoDetailLink'),
    linkUrl: config.MYWALLET_DETAIL_LINK_URL,
  },
  canAddMoneyToWallet: config.canAddMoneyToWallet,
  addMoneyButtonText: I18n.t('Dashboard.MyWallet.addMoney'),
  currentBalanceText: I18n.t('Dashboard.MyWallet.currentBalance'),
  goToAddMoneyPage: () => Navigation.dispatch(CommonActions.navigate({ name: 'addMoneyWithCreditCard' })),
});

export default compose(connect(mapStateToProps, mapDispatchToProps), withProps(withMyWalletProps))(MyWallet);
